import React from 'react';

// WUBRG-Farbdefinitionen für die Balken
const MANA_COLORS = {
  W: { label: 'Weiß', color: '#F0E5CE', border: '#D5C7A3' },
  U: { label: 'Blau', color: '#0E68AB', border: '#095A96' },
  B: { label: 'Schwarz', color: '#2B2525', border: '#1A1515' },
  R: { label: 'Rot', color: '#D3202A', border: '#B51A22' },
  G: { label: 'Grün', color: '#00733E', border: '#005C32' },
};

const COLOR_ORDER = ['W', 'U', 'B', 'R', 'G'];

/**
 * Rendert einen horizontalen Farbbalken proportional zu den Mana-Anteilen.
 */
export function ManaBar({ counts, label }) {
  const total = COLOR_ORDER.reduce((sum, c) => sum + (counts[c] || 0), 0);

  return (
    <div style={{ marginBottom: '4px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2px',
      }}>
        <span style={{
          fontSize: 'var(--text-xs)',
          color: 'var(--text-secondary)',
          fontWeight: 'var(--font-medium)',
        }}>{label}</span>
        {total > 0 && (
          <span style={{
            fontSize: 'var(--text-xs)',
            color: 'var(--text-muted)',
          }}>
            {COLOR_ORDER.filter(c => counts[c] > 0).map(c => `${counts[c]}${c}`).join(' ')}
          </span>
        )}
      </div>
      <div style={{
        display: 'flex',
        height: '14px',
        borderRadius: 'var(--radius-sm)',
        overflow: 'hidden',
        background: 'var(--bg-page)',
        border: '1px solid var(--border-subtle)',
      }}>
        {total === 0 ? (
          <div style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6rem',
            color: 'var(--text-muted)',
          }}>
            —
          </div>
        ) : (
          COLOR_ORDER.map((sym) => {
            const count = counts[sym] || 0;
            if (count === 0) return null;
            const pct = (count / total) * 100;
            return (
              <div
                key={sym}
                title={`${MANA_COLORS[sym].label}: ${count} (${Math.round(pct)}%)`}
                style={{
                  width: `${pct}%`,
                  backgroundColor: MANA_COLORS[sym].color,
                  minWidth: pct > 0 ? '3px' : 0,
                  transition: 'width 0.3s ease',
                  position: 'relative',
                }}
              />
            );
          })
        )}
      </div>
    </div>
  );
}

/**
 * Farbpunkte-Legende unterhalb der Balken.
 */
export function ManaLegend({ manaColorCounts = {}, manaProductionCounts = {} }) {
  // Nur Farben anzeigen die in mindestens einem Balken vorkommen
  const activeColors = COLOR_ORDER.filter(
    c => (manaColorCounts[c] || 0) > 0 || (manaProductionCounts[c] || 0) > 0
  );

  if (activeColors.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      gap: '8px',
      justifyContent: 'center',
      marginTop: '4px',
    }}>
      {activeColors.map((sym) => (
        <div key={sym} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '3px',
          fontSize: '0.65rem',
          color: 'var(--text-muted)',
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: MANA_COLORS[sym].color,
            border: `1px solid ${MANA_COLORS[sym].border}`,
            flexShrink: 0,
          }} />
          {sym}
        </div>
      ))}
    </div>
  );
}
